<template>
  <div>
    <wc-data-box
        :title='title'
        titleIcon='mdi-paperclip'
        titleIconColor='orange'
        :showAdd='!disabled'
        :loading='loading'
        @add='show_upload=true'
        showHelp
        :helpText='helpText'
    >
        <v-simple-table>
        <tbody>
            <template v-for='file in files'>
              <wc-file-field
                :key='file.file'
                :file='file.file_data'
                :description="file.description"
                :disabled='disabled'
                @delete='showDeleteFile'
                :send_file_enabled='send_file_enabled'
                :show_description="show_description"
                @sendFile='sendFile'
              />
            </template>
        </tbody>
        </v-simple-table>
    </wc-data-box>
    <wc-dialog
        width='350'
        :showDialog='show_upload'
        :disableButtons='!is_form_valid'
        :loadingButtons='is_uploading'
        saveText='Upload'
        title="Add File"
        @save='addFile'
        @cancel='cancelUpload'>
            <v-form v-model='is_form_valid'>
                <v-file-input
                    label='Choose a file'
                    v-model='file_to_be_uploaded'
                    :rules="[v => !!v || 'Please select a file']"
                ></v-file-input>
                 <v-select
                    :items='getFileTypes()'
                    required
                    :rules="[v => !!v || 'Field is required']"
                    label="File Type:"
                    v-model='file_type'
                    return-object
                ></v-select>
                <template v-if="show_description">
                    <v-text-field
                        label='Description'
                        v-model='description'
                        ></v-text-field>
                </template>
            </v-form>
        </wc-dialog>

        <wc-confirm-dialog
        width='400'
        :showDialog='show_delete'
        saveText='Confirm delete'
        icon='mdi-alert'
        iconColor='error'
        saveColor='error'
        title='Delete file'
        :loadingButtons='is_removing'
        :loading='is_removing'
        @confirm='deleteFile'
        @cancel='show_delete=false'>
        <p> Are you sure you want to delete this file?</p>
        </wc-confirm-dialog>
    </div>
</template>

<script>
import File from './row/File';
import filesAPI from '@/api/files';
import WCConfirmDialog from '@/components/dialogs/WCConfirmDialog';

export default {
  name: 'files',
  props: {
    files: {
      required: true
    },
    show_description: {
        required: false,
        default: false,
        type: Boolean
    },
    is_uploading:{
        required: false,
        default: false,
        type: Boolean
    },
    title: {
        required: false,
        default: 'Files',
        type: String
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    send_file_enabled: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    description: "",
    file_to_be_uploaded: null,
    file_id: null,
    file_type: null,
    show_delete: false,
    show_upload: false,
    is_form_valid: false,
    is_removing: false,
    helpText: 'Ensure pop-up blockers are off!<br><br>'
      + 'From an iPhone:<br>'
      + '<ul><li><strong>Safari:</strong> Main iPhone Settings —> Safari —> Block Pop ups (turn that off)</li>'
      + '<li><strong>Firefox:</strong> From within Firefox: Click burger menu bottom right —> Settings —> Block Pop ups (turn that off)</li>'
      + '<li><strong>Chrome:</strong> From within Chrome: Click three dots bottom right —> Settings —> Content Settings —> Block Pop-ups (turn that off)</li></ul>'
  }),
  methods: {
    showDeleteFile(file_id){
        this.show_delete = true;
        this.file_id = file_id;
    },
    async deleteFile(){
      this.is_removing = true;
      await filesAPI.deleteFile(this.file_id);
      this.is_removing = false;
      this.show_delete = false;
      const index = this.files.findIndex(file => file.id === this.file_id);
      this.files.splice(index, 1);
    },
    async addFile(){
        await this.$emit('add', this.file_type.value, this.file_to_be_uploaded, this.description);
        this.file_to_be_uploaded = null;
        this.show_upload = false;
    },
    getFileTypes(){
        return [
            {
                text: 'Sketch',
                value: 's'
            },
            {
                text: 'Asbuilt',
                value: 'a'
            },
            {
                text: 'First Call',
                value: 'f'
            },
            {
                text: 'Photo',
                value: 'p'
            }
        ]
    },
    cancelUpload() {
        this.show_upload = false;
        this.is_form_valid = false;
        this.file_type = null;
        this.file_to_be_uploaded = null;
    },
    sendFile(file_id){
      this.$emit('sendFile', file_id);
    }
  },
  components: {
    'wc-file-field': File,
    'wc-confirm-dialog': WCConfirmDialog
  }
}
</script>
